import { defaultRegionId } from './constants'
import { regions } from './data_types'
import { Region } from './types'
import { updateUrlQuery } from '@frontend/utils'

export const validateRegionId = (
  regionId: string | null,
  availableRegions: Region[]
): regionId is keyof typeof regions => {
  if (!regionId) return false
  return availableRegions.some((region) => region.id === regionId)
}

export const getInitialRegion = (
  availableRegions: Region[]
): keyof typeof regions => {
  // Check URL query parameter first
  const urlParams = new URLSearchParams(window.location.search)
  const regionParam = urlParams.get('region')

  if (validateRegionId(regionParam, availableRegions)) {
    localStorage.setItem('selectedRegionId', regionParam)
    return regionParam as keyof typeof regions
  }

  // Check local storage if no query parameter
  const selectedRegionId = localStorage.getItem('selectedRegionId')

  if (validateRegionId(selectedRegionId, availableRegions)) {
    updateUrlQuery('region', selectedRegionId)
    return selectedRegionId as keyof typeof regions
  }

  // Fallback to default region
  updateUrlQuery('region', defaultRegionId)
  return defaultRegionId
}

export const filterRegionsByAvailability = (
  availableRegionIds?: string
): Region[] => {
  const regionsArray = Object.values(regions)

  // If no availability string provided, return all regions
  if (!availableRegionIds || availableRegionIds.trim() === '') {
    return regionsArray
  }

  const allowedIds = availableRegionIds
    .split(',')
    .map((id) => id.trim())
    .filter((id) => id.length > 0)

  const filteredRegions = regionsArray.filter((region) =>
    allowedIds.includes(region.id)
  )

  // If no valid regions found, return all regions as fallback
  return filteredRegions.length > 0 ? filteredRegions : regionsArray
}
